import RPMToggleCarePlansList from './rpm-toggle-care-plans-list';

export default RPMToggleCarePlansList;
